<template>
    <i :class="icon || 'pi pi-star'"></i>
</template>

<script>
export default {
    name: 'tw-icon',
    props: {
        icon: {
            type: String
        }
    }
}
</script>
